var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKebabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_1875)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 0.01,
    stroke: "#292929",
    strokeLinejoin: "round",
    strokeWidth: 3,
    width: 0.01,
    x: 12,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    height: 0.01,
    stroke: "#292929",
    strokeLinejoin: "round",
    strokeWidth: 3,
    width: 0.01,
    x: 12,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 0.01,
    stroke: "#292929",
    strokeLinejoin: "round",
    strokeWidth: 3,
    width: 0.01,
    x: 12,
    y: 19
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_1875"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 24,
    transform: "translate(0 0.000976562)",
    width: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabIcon);
export default __webpack_public_path__ + "static/media/kebabIcon.e5a88033c59883b08c80c4431d01c466.svg";
export { ForwardRef as ReactComponent };